import { Controller } from '@hotwired/stimulus'
import { initDatepicker } from '../../modules/filtering/datepicker'
import fetchWithHandlingLoginRedirect from '../../modules/utils/fetchWithHandlingLoginRedirect'

export default class extends Controller {
  filterSetKeyPrefix = 'system_reports'

  static targets = [
    'fromDateDatepickerElementValue',
    'toDateDatepickerElementValue',
    'tableList',
    'smsMessagingMainSection'
  ]

  connect () {
    initDatepicker(this.filterSetKeyPrefix)
  }

  filter () {
    const filters = {
      from_date: $(this.fromDateDatepickerElementValueTarget).val(),
      to_date: $(this.toDateDatepickerElementValueTarget).val()
    }

    let querySearchTerm = ''

    if (filters.from_date) {
      querySearchTerm += `&from_date=${filters.from_date}`
    }

    if (filters.to_date) {
      querySearchTerm += `&to_date=${filters.to_date}`
    }

    this.tableListTarget.style.opacity = 0.1

    fetchWithHandlingLoginRedirect('/system-reports?table_list_partial=true ' + querySearchTerm).then(response => {
      response.text().then(text => {
        this.tableListTarget.style.opacity = 1
        this.smsMessagingMainSectionTarget.innerHTML = text

        initDatepicker(this.filterSetKeyPrefix)
        this.pushQueryParamsToUrl(filters)
      })
    }).catch(error => {
      // eslint-disable-next-line no-console
      console.error('Error:', error)
    })
  }

  clearFilters () {
    $(this.fromDateDatepickerElementValueTarget).val('')
    $(this.toDateDatepickerElementValueTarget).val('')
    this.filter()
  }

  removeFromDateFilter () {
    $(this.fromDateDatepickerElementValueTarget).val('')
    this.filter()
  }

  removeToDateFilter () {
    $(this.toDateDatepickerElementValueTarget).val('')
    this.filter()
  }

  pushQueryParamsToUrl (filters) {
    const fullCurrentUrl = new URL(window.location.href)
    const urlWithoutParams = `${fullCurrentUrl.protocol}//${fullCurrentUrl.host}${fullCurrentUrl.pathname}`

    const newParams = new URLSearchParams()
    if (filters.from_date) {
      newParams.set('from_date', filters.from_date)
    }

    if (filters.to_date) {
      newParams.set('to_date', filters.to_date)
    }
    const newUrl = Array.from(newParams.entries()).length === 0 ? urlWithoutParams : `${urlWithoutParams}?${newParams.toString()}`

    window.history.pushState({}, '', newUrl)
  }
}
